const { registerBlockType } = wp.blocks;

import Editor from './edit';
import Save from './save';
import attributes from './attributes';

registerBlockType('app/image-with-topics', {
  title: 'Imagem com tópicos',
  description:
    'Imagem com tópicos laterais, podendo escolher a posição (direita ou esquerda)',
  icon: 'table-col-after',
  category: 'design',
  attributes,

  edit: (props) => <Editor {...props} />,
  save: (props) => <Save {...props} />,
});
